<header>

    <!-- ======================== Navigation ======================== -->

    <div class="container">

        <!-- === navigation-main === -->

        <nav class="navigation-main clearfix">

            <!-- toggle-menu -->

            <div class="toggle-menu">
                <i class="icon icon-menu"></i>
            </div>

            <!-- navigation-block -->

            <div class="navigation-block clearfix">

                <!-- navigation-left -->

                <ul class="navigation-left">
                    <li>
                        <a href="/">Home </a>
                    </li>
                    <li>
                        <a [routerLink]="['/hotels']">Hotels List </a>
                    </li>
                    <li *ngIf="isAdmin">
                        <a [routerLink]="['/admin']">ADMIN </a>
                    </li>
                    <li *ngIf="(authService.user | async)">
                        <a [routerLink]="['/bookings']">Group Bookings </a>
                    </li>
                    <li *ngIf="(authService.user | async)">
                        <a style="cursor:pointer;" (click)="viewAddNewBooking()">Individual Bookings </a>
                    </li>
                </ul>

                <!-- navigation-right -->

                <ul class="navigation-right">
                    <!-- <li>
                        <a [routerLink]="['/restaurant']">Restaurants</a>
                    </li> -->

                    <li>
                        <a class="blink_me" [routerLink]="['/important-information']">Important Information</a>
                    </li>
                    <li *ngIf="!(authService.user | async)">
                        <a [routerLink]="['/register']">Create Account</a>
                    </li>
                    <li *ngIf="!(authService.user | async)">
                        <a [routerLink]="['/login']">Login</a>
                    </li>
                    <li>
                        <a style="color:white;" *ngIf="(authService.user | async)">
                            Logged in as:
                            <strong>{{(user$ | async)?.email}}</strong>
                        </a>
                    </li>
                    <li *ngIf="(authService.user | async)">
                        <a (click)="logout()" style="cursor:pointer;">Log Out </a>
                    </li>
                </ul>

            </div>
            <!--/navigation-block-->

        </nav>
    </div>
    <!--/container-->

</header>


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/core/components/header/header.component.html